import { Box } from '@mui/material'
import MerchantsListReport from './MerchantsListReport'

const Reports = () => {
  return (
    <Box display="flex" flexDirection="column" gap={2}>
      {<MerchantsListReport />}
    </Box>
  )
}

export default Reports
